import store from '../../store/modules/paramsClient-data';

export default {
  inserted(el, binding, vnode) {
    // To be sure that the state is Ready
    setTimeout(() => {
      const permissions = store.state.permissions;
      const values = binding.value.split(',');
      const hasPermission = values.some(v => permissions[v]);

      if (!hasPermission) {
        vnode.elm.parentElement.removeChild(vnode.elm);
        // OR
        // el.parentNode.removeChild(el);
      }
    }, 100);
  },
};



// WEBPACK FOOTER //
// ./src/core/directives/HasPermission.js